import * as React from 'react';
import { isPromise } from '../../../utils/utils';
/**
 * An internal hook to lazily set the state from a Promise
 * or something that is Promise A+ compliant. We really only
 * want this hook to run when the state is first initialized.
 */
export function useAsyncState(state, setShuttleState) {
    const resolved = React.useRef(false);
    React.useEffect(() => {
        if (isPromise(state) && !resolved.current) {
            state.then(data => {
                resolved.current = true;
                setShuttleState({ type: 'LAZY_LOAD', data });
            });
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
}
